import { Button, Col, Popconfirm, Row, Space, Tag } from 'antd';
import Table, { ColumnsType } from 'antd/lib/table';
import styled from 'styled-components';
import { Enterprise } from '../../modules/auth';
import { phoneFormatter } from '../../util/utils';
import { styledTable } from '../styled/mixin';

const StyledDiv = styled.div`
  ${styledTable}
`;

interface PartnerListComponentProps {
  partners: Enterprise[];
  isProjectLevel: boolean;
  deletePartner: (partnerId: string) => void;
  openPartnerDetailModal: (partnerId: string) => void;
}
function PartnerListComponent({
  partners,
  isProjectLevel,
  deletePartner,
  openPartnerDetailModal,
}: PartnerListComponentProps) {
  const columns: ColumnsType<Enterprise> = [
    {
      title: '업체명',
      dataIndex: 'name',
      width: '20%',
      render: (text: any, record: any) =>
        isProjectLevel ? (
          <span
            className="clickable-table-item"
            onClick={() => openPartnerDetailModal(record.id + '')}
          >
            {text}
          </span>
        ) : (
          <span>{text}</span>
        ),
    },
    {
      title: '대표명',
      dataIndex: 'representative',
    },
    {
      title: '주소',
      dataIndex: 'address',
    },
    {
      title: '연락처(회사)',
      dataIndex: 'corporatePhone',
      render: (text: any, record: any) => <>{phoneFormatter(text, 1)}</>,
    },
    {
      title: '공종',
      dataIndex: 'type2',
      width: '10%',
      render: (text: any, record: any) => (
        <>
          {text === null
            ? null
            : text.map((tag: any, index: any) => <Tag key={index}>{tag}</Tag>)}
        </>
      ),
    },
    {
      title: '',
      key: 'action',
      align: 'center',
      render: (text, record, index) => (
        <Space size="small">
          {isProjectLevel && (
            <div onClick={(e) => e.stopPropagation()}>
              <Popconfirm
                title="정말 삭제하시겠습니까?"
                onConfirm={() => deletePartner(record.id + '')}
              >
                <Button size="small" className="delete-table-list-item">
                  삭제
                </Button>
              </Popconfirm>
            </div>
          )}
        </Space>
      ),
    },
  ];

  let title;
  if (isProjectLevel) title = '참여';
  else title = '협력';

  return (
    <StyledDiv>
      <Row justify="space-between">
        <Col>
          <h3>{title}업체 리스트</h3>
        </Col>
      </Row>

      {partners && (
        <Table<Enterprise>
          rowKey="id"
          columns={columns}
          dataSource={partners}
          pagination={{
            defaultPageSize: 20,
            showSizeChanger: true,
            pageSizeOptions: ['10', '20', '30', '50', '100', '300'],
            position: ['bottomCenter'],
          }}
        />
      )}
    </StyledDiv>
  );
}

export default PartnerListComponent;
